export class TextareaController {
    constructor(root, params = {}) {
        this._root = root;
        this._params = params;

        this._$textarea = root.querySelector('textarea') || root; // Because it depends if you plug the module to the actual textarea tag, or the parent

        this._min = params.min;
        this._max = params.max;

        this._displayCounter = params.displayCounter;

        if (this._displayCounter) {
            this._$counter = this._generateDomCounter();
            this._$min = this._min && this._generateMinCounter();
            this._$max = this._max && this._generateMaxCounter();
        }

        this._isAutogrow = !!params.autogrow;

        this._counterDOMRefresh = this._counterDOMRefresh.bind(this);
        this._toggleActiveClass = this._toggleActiveClass.bind(this);
        this._setActive = this._setActive.bind(this);
        this._computeHeight = this._computeHeight.bind(this);
    }

    _setActive() {
        this._root.classList.add('active');
    }

    _setInactive() {
        this._root.classList.remove('active');
    }

    _toggleActiveClass() {
        const textareaValue = this._$textarea.value;

        if (textareaValue) {
            this._setActive();
        } else {
            this._setInactive();
        }
    }

    _getInvisibleBlock() {
        // this block is made the calculate precisely the height of our textarea
        // As textarea has a specific resize mecanism, it's more precise to bind its height to a neutral div
        // This div needs to have the same font-size properties
        return this._root.querySelector('[data-textarea-height]');
    }

    _createHeightCalculatorElement() {
        const div = document.createElement('div');
        div.setAttribute('data-textarea-height', '');
        div.classList.add('m-textarea__height-calculator');
        this._root.appendChild(div);
    }

    _computeHeight() {
        if (!this._getInvisibleBlock()) {
            this._createHeightCalculatorElement();
        }

        this._getInvisibleBlock().innerText = this._$textarea.value;

        const style = this._$textarea.currentStyle || window.getComputedStyle(this._$textarea);
        const paddingTop = parseInt(style.paddingTop);
        const paddingBottom = parseInt(style.paddingBottom);

        this._$textarea.style.height = this._getInvisibleBlock().clientHeight + (paddingTop + paddingBottom) + 'px';
    }

    _maxCounterRefresh() {
        this._$max.innerHTML = this._getMaxCounterString();
        if (this._max > this.getValueLength()) {
            this._$max.classList.remove('invalid');
        } else {
            this._$max.classList.add('invalid');
        }
    }

    _minCounterRefresh() {
        if (this._getMinCounterString() !== null) {
            this._$min.innerHTML = this._getMinCounterString();
        }
        if (this._min < this.getValueLength()) {
            this._$min.classList.remove('invalid');
        } else {
            this._$min.classList.add('invalid');
        }
    }

    _counterDOMRefresh() {
        this._$max && this._maxCounterRefresh();
        this._$min && this._minCounterRefresh();
    }

    _generateDomCounter() {
        const element = document.createElement('div');
        element.className = 'm-textarea__counter';
        this._root.appendChild(element);
        return element;
    }

    _generateMaxCounter() {
        const element = document.createElement('div');
        element.innerHTML = this._getMaxCounterString();
        element.className = 'm-textarea__counter-max';
        this._$counter.appendChild(element);
        return element;
    }

    isValid() {
        return !(this.getValueLength() > this._max || this.getValueLength() < this._min);
    }

    focus() {
        return this._$textarea.focus();
    }

    _generateMinCounter() {
        const element = document.createElement('div');
        element.innerHTML = this._getMinCounterString();
        element.className = 'm-textarea__counter-min';
        this._$counter.appendChild(element);
        return element;
    }

    getValueLength() {
        const {value} = this._$textarea;
        return value.replace(/\s{2,}/g, ' ').length;
    }

    _getMinCounterString() {
        if (this._params.minimumCharactersLabel) {
            return this._params.minimumCharactersLabel;
        }
        return null;
    }

    _getMaxCounterString() {
        return `${this.getValueLength()}/${this._max}`;
    }

    updateValue(value) {
        this._$textarea.value = value;
        this._computeHeight();
    }

    _addListeners() {
        this._$textarea.addEventListener('change', this._toggleActiveClass);
        this._$textarea.addEventListener('blur', this._toggleActiveClass);
        this._$textarea.addEventListener('focus', this._setActive);
        this._$textarea.addEventListener('input', this._counterDOMRefresh);
        if (this._isAutogrow) {
            this._$textarea.addEventListener('input', this._computeHeight);
            this._computeHeight();
        }
    }

    _removeListeners() {
        this._$textarea.removeEventListener('change', this._toggleActiveClass);
        this._$textarea.removeEventListener('blur', this._toggleActiveClass);
        this._$textarea.removeEventListener('focus', this._setActive);
        this._$textarea.removeEventListener('input', this._counterDOMRefresh);
        if (this._isAutogrow) {
            this._$textarea.removeEventListener('input', this._computeHeight);
        }
    }

    initialize() {
        this._addListeners();
        this._toggleActiveClass();
        this._counterDOMRefresh();
    }

    destroy() {
        this._removeListeners();
    }
}
